import { useMutation } from '@apollo/client/react';
import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useEffect } from 'react';

import {
  GetPatientProfileMedixsPatientDocument,
  GetReceptionPaneAppointmentDocument,
  IdentifyMedixsPatientDocument,
} from '~/graphql/generated/graphql';
import { medixsReceptionIdentificationModalState } from '~/state/partials/medixs_reception_identification_modal/atoms';

export const useIdentifyMedixsPatient = () => {
  const [{ patientId, appointmentId, selectedMedixsReception }, setState] = useAtom(
    medixsReceptionIdentificationModalState,
  );
  const resetState = useResetAtom(medixsReceptionIdentificationModalState);

  const [identifyMedixsPatient, { data, error, loading }] = useMutation(
    IdentifyMedixsPatientDocument,
    {
      refetchQueries: [
        {
          query: GetReceptionPaneAppointmentDocument,
          variables: { appointmentId },
        },
        { query: GetPatientProfileMedixsPatientDocument, variables: { patientId } },
      ],
    },
  );

  useEffect(() => {
    if (data?.identifyMedixsPatient) {
      resetState();
    }
  }, [data, resetState]);

  useEffect(() => {
    if (!error) return;
    setState((state) => ({
      ...state,
      error: error.message,
    }));
  }, [error, setState]);
  const identify = useCallback(() => {
    if (patientId && appointmentId && selectedMedixsReception) {
      identifyMedixsPatient({
        variables: {
          input: {
            patientId,
            appointmentId,
            medixsPatientId: selectedMedixsReception.medixsPatient.id,
            medixsReceptionId: selectedMedixsReception.id,
          },
        },
      });
    }
  }, [patientId, appointmentId, selectedMedixsReception, identifyMedixsPatient]);

  return { identifying: loading, identify };
};
